import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../utils/data-load-error/data-load-error";

export enum DriverCandidatureActiveErrorType {
  NOT_ACTIVE = "NOT_ACTIVE",
}

export type DriverCandidatureNotActiveError = DataLoadError<
  DriverCandidatureActiveErrorType.NOT_ACTIVE,
  {}
>;

type DriverCandidatureActiveError =
  | DataLoadDefaultErrors
  | DriverCandidatureNotActiveError;

export default DriverCandidatureActiveError;
